import { render, staticRenderFns } from "./WeekScheduleSection.vue?vue&type=template&id=1ba1cb0e&"
import script from "./WeekScheduleSection.vue?vue&type=script&lang=ts&"
export * from "./WeekScheduleSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports